module.exports = __webpack_public_path__ + "img/bg-threat-low.3a6b8f69.png";